// 2FA + profile-password API client.
// All requests go through the shared axios instance which injects the
// x-access-token header and the x-trusted-device header automatically.
import axios from '../../axios/index.js'

export default {
  status () {
    return axios.get('/auth/2fa/status')
  },
  setupEmailStart () {
    return axios.post('/auth/2fa/setup/email/start')
  },
  setupEmailVerify (code) {
    return axios.post('/auth/2fa/setup/email/verify', { code })
  },
  setupTotpStart () {
    return axios.post('/auth/2fa/setup/totp/start')
  },
  setupTotpVerify (code) {
    return axios.post('/auth/2fa/setup/totp/verify', { code })
  },
  sendEmailChallenge () {
    return axios.post('/auth/2fa/email/challenge')
  },
  disable ({ currentPassword, code, useRecovery }) {
    return axios.post('/auth/2fa/disable', { currentPassword, code, useRecovery: !!useRecovery })
  },
  regenerateRecoveryCodes ({ code, useRecovery }) {
    return axios.post('/auth/2fa/recovery-codes/regenerate', { code, useRecovery: !!useRecovery })
  },
  signin2fa ({ challengeToken, code, useRecovery, rememberDevice }) {
    return axios.post('/auth/signin/2fa', {
      challengeToken,
      code,
      useRecovery: !!useRecovery,
      rememberDevice: rememberDevice !== false // default true
    })
  },
  changePassword ({ currentPassword, newPassword }) {
    return axios.post('/profile/password', { currentPassword, newPassword })
  },
  // Admin-only: reset another user's 2FA (lost authenticator).
  adminResetTwofa (userId) {
    return axios.post(`/auth/2fa/admin/reset/${userId}`)
  }
}
